export const FilterConstants = {
  RESET: 'Reset',
  CALENDAR: 'Calendar'
}
